import { setEntityDataSuccess } from 'containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';
import {
    fetchEntityHierarchyRequest,
    fetchEntityListRequest,
} from 'containers/MerchantOnboard/redux/merchantOnBoard.actions';

import {
    Table,
    TableFilter,
    Popup,
    ViewAdjustment,
    TableSearch,
    CreateAdjustmentForm,
    ViewDownloadStatus,
} from '../../components';
import {
    ADJUSTMENT_TYPE,
    ENTITY_TYPE,
} from '../../utils/constants/commonValues';

import {
    fetchAdjustmentsRequest,
    generateReportRequest,
    generateReportError,
} from './redux/adjustments.actions';
import { ADJUSTMENT_CATEGORY } from './constant';
import DownloadFile from './DownloadFile';
import React, {
    useMemo,
    useState,
    useCallback,
    useEffect,
    useRef,
    Fragment,
} from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import './adjustment.scss';

let filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {
            startDate: moment()
                .endOf('day')
                .subtract(1, 'days'),
            endDate: moment().endOf('day'),
            maximumNights: 30,
            notResetDate: true,
        },
    },

    {
        fieldType: 'search-select',
        label: 'Merchant Name',
        name: 'merchantName',
        props: {
            data: [],
            label: 'Select Merchant',
            labelField: 'name',
            valueField: 'entityCode',
            entityType: 'MERCHANT_NAME',
        },
    },
    {
        fieldType: 'search-select',
        label: 'Merchant ID',
        name: 'merchantId',
        props: {
            data: [],
            label: 'Select Merchant',
            labelField: 'entityCode',
            valueField: 'entityCode',
            entityType: 'MERCHANT',
        },
    },

    {
        fieldType: 'search-select',
        label: 'Adjustment Category',
        name: 'adjustmentCategory',
        props: {
            data: ADJUSTMENT_CATEGORY,
            label: 'Select Adjustment Category',
            labelField: 'name',
            valueField: 'value',
        },
    },
    {
        fieldType: 'checkbox',
        label: 'Adjustment Type',
        name: 'adjustmentType',
        props: {
            options: (() => {
                const options = [];
                for (const key in ADJUSTMENT_TYPE) {
                    if (
                        Object.prototype.hasOwnProperty.call(
                            ADJUSTMENT_TYPE,
                            key
                        )
                    ) {
                        const value = ADJUSTMENT_TYPE[key];
                        options.push({
                            name: value,
                            value: key,
                        });
                    }
                }
                return options;
            })(),
            labelField: 'name',
            valueField: 'value',
        },
    },
];

const MerchantAdjustmentAction = ({ data, fetchData }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);
    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };
    const handleCloseOpenActionPopup = () => {
        setShowFilter(false);
        setActionType(null);
    };
    return (
        <div className="userAction  multiItem">
            <button className="view" onClick={handleOpenActionPopup} />
            <Popup
                title={data.original.merchantName}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={data.original}
                closePopup={handleCloseOpenActionPopup}
            >
                <ViewAdjustment
                    actionType={actionType}
                    data={data.original}
                    fetchData={fetchData}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                />
            </Popup>
        </div>
    );
};

const setMerchantFilter = (fieldsList, underlyingMerchant, handleSearchEnd) => {
    if (underlyingMerchant.length) {
        fieldsList.forEach(element => {
            if (element.name === 'merchantId' || element.name === 'merchantName') {
                element.props.data = underlyingMerchant;
                element.props.handleSearchEnd = handleSearchEnd;
            }
        });
        return fieldsList;
    }
    return fieldsList.filter(item => item.name !== 'merchantId');
};

// eslint-disable-next-line max-statements
const MerchantAdjustments = props => {
    const {
        adjustmentsData,
        transactionData,
        actions,
        loader: { showLoader },
        merchantData,
        auth,
    } = props;

    const {
        error,
        tableData,
        isLoading,
        pagination,
        statusData,
        generatedFile,
    } = adjustmentsData;
    // reusing txn get active reports saga
    const { activeReports = {} } = transactionData || {};

    const { entityList } = merchantData;
    const [filterData, setFilterData] = useState({ isLive: true });
    const { userLevel, associatedEntityId } = auth.userDetails;

    const columns = useMemo(
        () => [
            { header: 'Merchant Name', accessor: 'merchantName' },
            { header: 'Merchant Id', accessor: 'merchantId' },
            { header: 'Adjustment Id', accessor: 'adjustmentId' },
            { header: 'Adjustment Type', accessor: 'adjustmentType' },
            { header: 'Created On', accessor: 'adjustmentDateAndTime' },
            { header: 'Amount', accessor: 'adjustmentAmount' },
            { header: 'Category', accessor: 'adjustmentcategory' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isResetPage, setIsResetPage] = useState(false);
    const [showFilter, setShowFilter] = useState(false);

    const [showDownloadPopup, setShowDownloadPopup] = useState(false);
    const createAdjustmentRef = useRef(false);

    const handleViewDownloads = () => {
        createAdjustmentRef.current = false;
        setShowFilter(true);
    };

    const handleCloseViewDownload = () => {
        setShowFilter(false);
    };

    useEffect(() => {
        actions.fetchEntityListRequest(ENTITY_TYPE.MERCHANT);
    }, [actions]);

    // remove filters for specific users
    useEffect(() => {
        // if merchant remove merchant
        if (userLevel && userLevel === 'MERCHANT') {
            filterFieldList = filterFieldList.filter(
                filter => filter.name !== 'merchantId'
            );
        }
    }, [userLevel]);

    const fetchData = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            const data = {
                pageSize,
                pageIndex,
            };
            if (
                filterData.createdOn &&
                Object.keys(filterData.createdOn).length &&
                userLevel
            ) {
                // for aggregator show split txn in default view
                if (userLevel === 'AGGREGATOR' && !filterData.merchantIds) {
                    actions.fetchAdjustmentsRequest({
                        ...data,
                        ...filterData,
                        merchantIds: [associatedEntityId],
                    });
                } else {
                    actions.fetchAdjustmentsRequest({
                        ...data,
                        ...filterData,
                    });
                }
            }
            setPageSize(pageSize);
        },
        [actions, associatedEntityId, filterData, userLevel]
    );

    useEffect(() => {
        if (generatedFile.isSuccess) {
            setShowFilter(true);
            setShowDownloadPopup(false);
        }
        return () => {
            actions.generateReportError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generatedFile.isSuccess]);

    useEffect(() => {
        if (userLevel) {
            // for aggregator request only when auth data is present
            fetchData({ pageIndex: 0, pageSize: 10 });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userLevel]);

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    const handleSearchSubmit = searchQuery => {
        if (searchQuery) {
            actions.fetchAdjustmentsRequest({
                merchantCode: searchQuery,
            });
        } else {
            actions.fetchAdjustmentsRequest({
                merchantCode: searchQuery,
                createdOn: filterData.createdOn,
            });
        }
    };

    const handleSearchEnd = (value, entityType) => {
        const type = entityType === 'MERCHANT_NAME' ? 'MERCHANT' : entityType;
        const filtered = entityList[type.toLowerCase()]?.filter(item => {
            const key = entityType === 'MERCHANT' ? 'entityCode' : 'name';
            return item[key]?.toLowerCase().includes(value.toLowerCase());
        }) || [];

        const data = {
            entityName: ['MERCHANT_NAME', 'AGGREGATOR'].includes(entityType) ? value : '',
            entityCode: !['MERCHANT_NAME', 'AGGREGATOR'].includes(entityType) ? value : ''
        };

        if (filtered.length === 0 && value.length >= 3) {
            actions.fetchEntityListRequest(type, data);
        }
    };


    const filters = setMerchantFilter(
        filterFieldList,
        entityList.merchant || [],
        handleSearchEnd,
    );

    const filterSubmitHandler = filterValues => {
        const { merchantId, merchantName } = filterValues;
        delete filterValues.merchantIds;
        let merchantIds = [];
        if (merchantId) {
            merchantIds.push(merchantId);
        }
        if(merchantName){
            merchantIds.push(merchantName);
        }
        if (merchantIds.length) {
            merchantIds = [...new Set(merchantIds)];
            filterValues.merchantIds = merchantIds;
        }
        setFilterData({ ...filterValues, isLive: filterData.isLive });
        setIsResetPage(true);
    };

    const onClickCreateAdjustment = () => {
        createAdjustmentRef.current = true;
        setShowFilter(true);
    };



    return (
        <div className="adjustment-wrapper">
            <Table
                tableTitle="Merchant Adjustments"
                columns={columns}
                isFiltersEnable
                isPaginationEnable
                data={tableData}
                filterData={filterData}
                error={error && error.errorMessage}
                loading={showLoader || isLoading}
                pageCount={pageCount}
                fetchData={fetchData}
                numberOfRecord={pagination.totalNumberOfRecords}
                pageSizeOptions={pageSizeOptions}
                paginationLabel="Rows per page"
                pagePerView={3}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
                onClickTableAction={handleViewDownloads}
                tableSearch={
                    <Fragment>
                        <div
                            className="create-adjustment createAction"
                            onClick={onClickCreateAdjustment}
                        >
                            Create Adjustment
                        </div>
                        <div className="search">
                            <div>
                                <TableSearch
                                    handleSearchSubmit={handleSearchSubmit}
                                    placeholder="Search"
                                />
                            </div>
                        </div>
                    </Fragment>
                }
                userActions={data => (
                    <MerchantAdjustmentAction
                        data={data}
                        statusData={statusData}
                        fetchData={fetchData}
                    />
                )}
                tableFilters={
                    <TableFilter
                        customFilterClass="rightSkewed"
                        showOverlay
                        fieldsList={filters}
                        onSubmit={filterValues =>
                            filterSubmitHandler(filterValues)
                        }
                        onReset={resetValue => {
                            setFilterData({
                                isLive: filterData.isLive,
                                ...resetValue,
                            });
                            setIsResetPage(true);
                        }}
                    />
                }
                filterActionTitle="View Downloads"
                tableActionPopup={
                    <Popup
                        title={
                            createAdjustmentRef.current
                                ? 'CREATE ADJUSTMENT'
                                : 'VIEW DOWNLOADS'
                        }
                        showCloseIcon
                        showOverlay
                        showFilter={showFilter}
                        closePopup={handleCloseViewDownload}
                    >
                        {createAdjustmentRef.current ? (
                            <CreateAdjustmentForm fetchData={fetchData} />
                        ) : (
                            <ViewDownloadStatus data={activeReports.reports} />
                        )}
                    </Popup>
                }
                additionalActions={() => (
                    <DownloadFile
                        filterData={filterData}
                        tableData={tableData}
                        actions={actions}
                        showDownloadPopup={showDownloadPopup}
                        setShowDownloadPopup={setShowDownloadPopup}
                        generateData={generatedFile}
                    />
                )}
            />
        </div>
    );
};

const mapStateToProps = ({
    auth,
    adjustmentsData,
    loader,
    staticData,
    merchantData,
    transactionData,
}) => ({
    auth,
    adjustmentsData,
    loader,
    staticData,
    merchantData,
    transactionData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchAdjustmentsRequest,
            generateReportRequest,
            generateReportError,
            setEntityDataSuccess,
            fetchEntityListRequest,
            fetchEntityHierarchyRequest,
        },
        dispatch
    ),
});

MerchantAdjustments.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    adjustmentsData: PropTypes.object,
    transactionData: PropTypes.object,
    staticData: PropTypes.object,
    loader: PropTypes.object,
    merchantData: PropTypes.object.isRequired,
};

MerchantAdjustmentAction.propTypes = {
    data: PropTypes.object,
    fetchData: PropTypes.func,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MerchantAdjustments);
